import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { closeOrderWindow, updateOrderWindowType } from '../../store/actions/orders';
import OrderWindow from './OrderWindow';


const OrderWindowHOC = () => {
    const dispatch = useDispatch();
    const orderWindow = useSelector(state => state.orders.orderWindow);
    const {formattedWatchlists} = useSelector(
        (state) => state.marketwatch
      );

    const handleClose = () => {
        dispatch(closeOrderWindow());
    };

    const handleTypeChange = (newType) => {
        dispatch(updateOrderWindowType(newType));
    };

    // Only render if we have all required data
    if (!orderWindow.open || !orderWindow.trading_symbol || !orderWindow.token) {
        return null;
    }
    return (
        <OrderWindow
            {...orderWindow}
            formattedWatchlists={formattedWatchlists}
            onClose={handleClose}
            onTypeChange={handleTypeChange}
        />
    );
};

export default OrderWindowHOC; 